import React from 'react'
import styled from 'styled-components/macro'

const SupplierLogo = ({ logoUrl, title, size = 40, style }) => (
  <LogoContainer $size={size} style={style}>
    {logoUrl ? (
      <img src={logoUrl} alt={title ? `${title} logo` : 'Supplier logo'} />
    ) : (
      <Initial>{title?.charAt(0)?.toUpperCase() || '?'}</Initial>
    )}
  </LogoContainer>
)

const LogoContainer = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  min-width: ${({ $size }) => $size}px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  background: #fafafa;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
  }
`

const Initial = styled.span`
  font-size: ${({ theme }) => theme.fontSizes?.md || '16px'};
  font-weight: 600;
  color: #8c8c8c;
`

export default SupplierLogo
